import { useNavigate } from "react-router-dom";
import { AuthLayout, ButtonBlockPrimary, InputSearchGray } from "../../components";
import { useState } from "react";
import { searchMitra } from "../../service/authService";

const SearchMitra = () => {
    const router = useNavigate();
    const [keyword, setKeyword] = useState("");

    const getDataMitra = async () => {
        const params = {
            keyword: keyword
        }

        const response = await searchMitra(params);
        if (response.code === 200 && !response.error) {

            const users = response.data
            router(`/search-mitra/${users.uniqueId}`, { state: { users: users } })
        }
    }

    return (
        <AuthLayout title='Cari Data Mitra'>
            <div className='py-5'>
                <div className="w-full flex justify-center lg:mt-8 mt-20">
                    <img className="w-80"
                        src="/assets/imgs/animate-search.gif" alt="" />
                </div>
                <div className='my-2'>
                    <InputSearchGray
                        value={keyword}
                        onChange={(e) => { setKeyword(e.target.value) }}
                        placeholder='Masukan Email atau ID Mitra'
                        icon={'FaSistrix'} />
                </div>
                <div className='my-4'>
                    <ButtonBlockPrimary label='Search' onClick={() => { getDataMitra() }} />
                </div>
            </div>
        </AuthLayout>
    );
};

export default SearchMitra;